import { HiHome } from "react-icons/hi";
import PageNav from "../../PageNav";
import moment from "moment";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { FcCalendar } from "react-icons/fc";
import { setToken } from "../../../utils/token";
import { toast } from "react-hot-toast";
import { Table, Button } from "antd";
import { useDispatch } from "react-redux";
import {
  setCountry,
  setProjectSiteId,
  setProjectSiteName,
  settimezone,
} from "../../../redux/slice/projectsiteSlice";
import {
  updateRole,
  updateUsername,
} from "../../../redux/slice/userDetailSlice";
import { setNavtitle } from "../../../redux/slice/layoutSlice";

const UserRolesTable = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewDashboard = async (item) => {
    try {
      dispatch(updateUsername(item?.username));
      dispatch(setProjectSiteId(item?.siteid) ?? "");
      dispatch(setProjectSiteName(item?.sitename ?? ""));
      dispatch(setCountry(item?.country ?? ""));
      dispatch(settimezone(item?.timezone));

      switch (item?.role) {
        case "System Manager":
          dispatch(updateRole("System Manager"));
          await setToken("spiral_role", "System Manager");
          navigate(`/dashboard/systemadmin`);
          dispatch(setNavtitle("System Manager Dashboard"));
          return;
        case "Project Manager":
          dispatch(updateRole("Project Manager"));
          dispatch(setNavtitle("Project Manager Dashboard"));
          navigate(`/dashboard/projectmanager`);
          return;
        case "Customer Representative":
          dispatch(updateRole("Customer Representative"));
          dispatch(setNavtitle("Customer Rep Dashboard"));
          navigate(`/dashboard/customerrepresentative`);
          return;
        case "Customer Manager":
          dispatch(updateRole("Customer Manager"));
          dispatch(setNavtitle("Customer Manager Dashboard"));
          navigate(`/dashboard/customermanager`);
          return;
        case "Sales Agent":
          dispatch(updateRole("Sales Agent"));
          dispatch(setNavtitle("Sales Agent Dashboard"));
          navigate(`/dashboard/salesagent`);
          return;
        default:
          break;
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const columns = [
    {
      title: "Created by",
      dataIndex: "creator",
      key: "creator",
      align: "center",
      render: (creator) => (
        <div className="text-xs">{creator ? creator : "Chanels"}</div>
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      align: "center",
      render: (username) => (
        <div className="text-xs">{username ? username : "-"}</div>
      ),
    },
    {
      title: "Site Managed",
      dataIndex: "sitename",
      key: "sitename",
      align: "center",
      sorter: true,
      render: (sitename) => (
        <div className="text-xs">{sitename ? sitename : "-Nil-"}</div>
      ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      align: "center",
      sorter: true,
      render: (role) => <div className="text-xs text-secondary">{role}</div>,
    },
    {
      title: "Date assigned",
      dataIndex: "datecreated",
      key: "datecreated",
      align: "center",
      sorter: true,
      render: (datecreated) => (
        <div className="flex items-center justify-center">
          <div className="px-1">
            <FcCalendar size={18} />
          </div>
          <div className="text-xs">{moment(datecreated).format("lll")}</div>
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Button
          type="default"
          size="small"
          className="border border-gray-400"
          onClick={() => handleViewDashboard(record)}
        >
          View dashboard
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={{
        pageSize: 10,
        showSizeChanger: false,
        showQuickJumper: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }}
      size="small"
      rowKey={(record) => record.username || record.siteid}
      scroll={{ x: 800 }}
    />
  );
};

export default UserRolesTable;
